import { useOrganization } from '@/contexts/OrganizationContext';
import { useFeatureAccess } from '@/hooks/useFeatureAccess';
import { FEATURE_FLAG_KEYS } from '@/lib/featureFlagsCatalog';

/**
 * ENT-6257 (D6): whether the supplier-profile stewardship UI is exposed for the acting
 * organisation. `supplier_profile_stewardship` is organisation-targeted, so it is only resolved
 * once an organisation is known (an unscoped request is refused 400 organization_id_required,
 * ENT-5889). While it resolves, with no organisation, or when it is off, every surface renders
 * its pre-change markup. Exposure only: the backend enforces stewardship regardless.
 */
export function useSupplierProfileStewardshipUi(): boolean {
  const { organization } = useOrganization();
  const feature = useFeatureAccess(FEATURE_FLAG_KEYS.supplierProfileStewardship, {
    source: 'beta_feature',
    enabled: Boolean(organization?.id),
  });
  return !feature.isLoading && feature.enabled;
}
